import React from 'react'
import { Grid } from '@material-ui/core'
// import GroupSelect from './GroupSelect'
import TextField from './TextField'
// import Suggestions from './Suggestions'
import language from 'utils/vast-languagepack'

export default () => (
  <Grid container spacing={24}>
    <Grid item xs={12}>
      <TextField
        property="formName"
        label={language.signupform.add.labels.formName}
      />
    </Grid>
    {/* <Grid item xs={12}>
      <Typography variant="caption" gutterBottom>
        {language.signupform.add.helperText.groupInfo}
      </Typography>
      <GroupSelect />
      <Suggestions />
    </Grid> */}
  </Grid>
)
